export default __webpack_public_path__ + "fonts/f00b85003afb7e6d571a1c15a51ff703.ttf";